import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface MethodologyStepProps {
  step: {
    id: number;
    number: string;
    title: string;
    description: string;
    icon: string;
    duration: string;
  };
  index: number;
}

const MethodologyStep = ({ step, index }: MethodologyStepProps) => {
  return (
    <div className="relative group">
      <div className="glassmorphic rounded-xl p-6 hover:shadow-premium transition-all duration-500 hover:-translate-y-1 shadow-silver-glow hover:shadow-orange-glow-hover card-3d-glow">
        <div className="absolute -top-4 -left-4 w-12 h-12 rounded-full bg-gradient-to-br from-primary to-secondary flex items-center justify-center font-display font-bold text-lg text-background shadow-elevated">
          {step.number}
        </div>

        <div className="flex items-start gap-4 mb-4">
          <div className="flex-shrink-0 w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center group-hover:bg-primary/20 transition-colors duration-300">
            <Icon name={step.icon as any} size={24} className="text-primary" />
          </div>
          <div className="flex-1">
            <h3 className="text-lg font-display font-bold text-foreground mb-2 group-hover:text-primary transition-colors duration-300">
              {step.title}
            </h3>
            <p className="text-sm text-muted-foreground leading-relaxed">
              {step.description}
            </p>
          </div>
        </div>

        <div className="flex items-center gap-2 text-xs text-primary font-medium">
          <Icon name="ClockIcon" size={16} />
          <span>{step.duration}</span>
        </div>
      </div>

      {index < 5 && (
        <div className="hidden lg:block absolute top-1/2 -right-8 w-16 h-0.5 bg-gradient-to-r from-primary/50 to-transparent"></div>
      )}
    </div>
  );
};

export default MethodologyStep;